import api from '@/api/dashboard/api'

const getCollection = params => api({
  method: 'get',
  url: 'contacts',
  params
})

const getOffice = slug => api({
  method: 'get',
  url: `contacts/${slug}`
})

export {
  getCollection,
  getOffice
}